import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../../core/clock.js";
import { InputHandler as e } from "../InputHandler.js";
import { DefaultParameters as i } from "./SingleAndDoubleClick.js";
import { manhattanDistance as o } from "./support.js";

var n = /*#__PURE__*/function (_e) {
  _inherits(n, _e);

  var _super = _createSuper(n);

  function n() {
    var _this;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : i.maximumDoubleClickDelay;
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : i.maximumDoubleClickDistance;

    var _n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : i.maximumDoubleTouchDelay;

    var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : i.maximumDoubleTouchDistance;
    var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : t;

    _classCallCheck(this, n);

    _this = _super.call(this, !1), _this.maximumDoubleClickDelay = e, _this.maximumDoubleClickDistance = o, _this.maximumDoubleTouchDelay = _n, _this.maximumDoubleTouchDistance = a, _this._clock = s, _this._pointerState = new Map(), _this._immediateDoubleClick = _this.registerOutgoing("immediate-double-click"), _this.registerIncoming("pointer-down", _this._handlePointerDown.bind(_assertThisInitialized(_this))), _this.registerIncoming("pointer-up", function (t) {
      _this._handlePointerLoss(t, "pointer-up");
    }), _this.registerIncoming("pointer-capture-lost", function (t) {
      _this._handlePointerLoss(t, "pointer-capture-lost");
    }), _this.registerIncoming("pointer-cancel", function (t) {
      _this._handlePointerLoss(t, "pointer-cancel");
    });
    return _this;
  }

  _createClass(n, [{
    key: "onUninstall",
    value: function onUninstall() {
      this._pointerState.forEach(function (t) {
        t.immediateDoubleClick && t.immediateDoubleClick.timeoutHandle.remove();
      }), _get(_getPrototypeOf(n.prototype), "onUninstall", this).call(this);
    }
  }, {
    key: "_handlePointerDown",
    value: function _handlePointerDown(t) {
      var e = t.data,
          i = this._pointerId(e);

      if (!this._pointerState.has(i)) {
        var _t = {
          downButton: e.native.button,
          immediateDoubleClick: null
        };
        this._pointerState.set(i, _t), this.startCapturingPointer(e.native);
      }
    }
  }, {
    key: "_handlePointerLoss",
    value: function _handlePointerLoss(t, e) {
      var i = t.data,
          _n2 = this._pointerId(i),
          a = this._pointerState.get(_n2);

      if (a && "pointer-up" === e && a.downButton === i.native.button) {
        var _e2 = a.immediateDoubleClick;

        if (_e2) {
          _e2.timeoutHandle.remove();

          var _n4 = "touch" === t.data.native.pointerType ? this.maximumDoubleTouchDistance : this.maximumDoubleClickDistance;

          o(_e2, t.data) > _n4 ? this._startImmediateDoubleClick(t, a) : (this._immediateDoubleClick.emit(t.data, void 0, _e2.modifiers), this._removeState(i));
        } else this._startImmediateDoubleClick(t, a);
      }
    }
  }, {
    key: "_startImmediateDoubleClick",
    value: function _startImmediateDoubleClick(t, e) {
      var _this2 = this;

      var i = "touch" === t.data.native.pointerType ? this.maximumDoubleTouchDelay : this.maximumDoubleClickDelay;
      e.immediateDoubleClick = {
        x: t.data.x,
        y: t.data.y,
        modifiers: t.modifiers,
        timeoutHandle: this._clock.setTimeout(function () {
          return _this2._removeState(t.data);
        }, i)
      };
    }
  }, {
    key: "_pointerId",
    value: function _pointerId(t) {
      var e = t.native;
      return "mouse" === e.pointerType ? "".concat(e.pointerId, ":").concat(e.button) : "".concat(e.pointerType);
    }
  }, {
    key: "_removeState",
    value: function _removeState(t) {
      var e = this._pointerId(t);

      this._pointerState.delete(e), this.stopCapturingPointer(t.native), this.refreshHasPendingInputs();
    }
  }]);

  return n;
}(e);

export { n as ImmediateDoubleClick };